import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { selectIsSmallScreen } from 'store/pageStore';
import { BenefitType } from '../benefit-list/benefits-db';
import {
	benefitItemStyles,
	benefitItemWrapperStyles,
	benefitItemTextContainerStyles,
	titleStyles,
} from './styles';

type BenefinProps = BenefitType & {
	onClick: (number) => void;
	id: number;
};

export const BenefitItem = ({
	title,
	text,
	textMobile,
	bgSrc,
	bgSrcMobile,
	id,
	onClick,
}: BenefinProps) => {
	const isSmallScreen = useSelector(selectIsSmallScreen);
	const handleClick = () => {
		onClick(id);
	};
	return (
		<div className={benefitItemStyles} onClick={handleClick}>
			<div
				className={benefitItemWrapperStyles}
				data-qa="benefit-bg"
				style={{ backgroundImage: `url('${!isSmallScreen ? bgSrc : bgSrcMobile}')` }}
			>
				<div className={benefitItemTextContainerStyles}>
					<div>
						<Typography className={titleStyles} variant="m" size="body_accent">
							{title}
						</Typography>
					</div>
					<div>
						<Typography variant="s" size="body_long">
							{!isSmallScreen ? text : textMobile}
						</Typography>
					</div>
				</div>
			</div>
		</div>
	);
};
